<template>
  <div id='liveblock'>
    <top v-if='shouldRenderTop'></top>
    <slider v-if='shouldRenderSlider'></slider>    
  </div>
</template>

<script>
import mixins from './mixins'
import Top from './components/Top/Top'
import Slider from './components/Slider/Slider'

export default {
  mixins: [mixins],
  name: 'liveblock',
  components: {
    Top,
    Slider
  },
  data () {
    return {
      shouldRenderTop: false,
      shouldRenderSlider: false
    }
  },
  created () {
    this.$http.get(this.$root.cmsData.serviceUrl, {headers: {'Accept-Language': this.$root.cmsData.lang}}).then(response => {
      this.$root.liveData = response.body
      if (this.liveHelper().shouldShowSlider(this.$root.cmsData, this.$root.liveData)) {
        this.shouldRenderSlider = true
      }
    }, response => {
      this.$root.errorNoData = true
      this.shouldRenderSlider = true
    }).finally(function () {
      this.shouldRenderTop = true
    })
  }
}
</script>
<style>
/* @import '../../../public/css/app.min.css'; */
</style>



// WEBPACK FOOTER //
// Liveblock.vue?06d243d6